import moment from 'moment';


export default function PRABoardApproveDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  praDataService,
  reportsDataService,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveBoardApprove = _handleSaveBoardApprove;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.approvedById = -1;
    vm.boardApprovedMinDate = moment().add(-18, 'months');
    vm.boardApprovedCurrentDate = moment().add(0, 'days');
    vm.boardApprovedMaxDate = vm.boardApprovedCurrentDate;
    vm.boardApprovedDate = vm.boardApprovedCurrentDate.format('MM/DD/YYYY');
    vm.confirmSubmit = false;
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.boardApproveDialog);
  }

  function _handleSaveBoardApprove() {
    if ($scope.praBoardApproveForm.$invalid) {
      return;
    }

    vm.boardApprovedDate = vm.boardApprovedCurrentDate.format('MM/DD/YYYY');
    praDataService.approveAssessment(vm.assessmentId, vm.approvedById, vm.boardApprovedDate).then((response) => {
      if (!response.data.result) {
        alerts.error('Error occurred while saving Board Approval.');
      } else {
        alerts.success('The PRA Assessment was successfully Board Approved.');
        alerts.info('Please Wait! Updating document with Approved date. This may take a while');
        $rootScope.$broadcast('refreshPRAAssessments');
        ssDialogService.hide(ssDialogService.dialogs.pra.boardApproveDialog);
        alerts.info('Please Wait! Queueing report. It may take little longer than normal to get the report');
        loaderService.showViewLoader = true;
        const downloadCall = praDataService.generateFullReport(
          {
            assessmentId: vm.assessmentId,
            name: vm.assessmentName,
            renderFullReport: true,
            saveDocument: true,
          }
        );
        downloadCall.then((downloadDocumentResponse) => {
          alerts.success('The PRA assessment document was generated successfully.');
          loaderService.showViewLoader = false;
          reportsDataService.download(downloadDocumentResponse);
        });
      }
    });
  }
}

PRABoardApproveDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'praDataService',
  'reportsDataService',
];
